import React from 'react';
import PropTypes from 'prop-types';
import RadioButton from './CustomQuestions/RadioButton';
import CheckboxButton from './CustomQuestions/CheckboxButton';
import Input from './CustomQuestions/Input';
import TextArea from './CustomQuestions/TextArea';
import SingleSelectGroup from './CustomQuestions/SingleSelectGroup';
import MultipleSelectGroup from './CustomQuestions/MultipleSelectGroup';
import { CategoryType } from './types';

const TYPE_COMPONENT_MAP = {
  'Radio Button': RadioButton,
  'Check Box': CheckboxButton,
  Input: Input,
  Textarea: TextArea,
  'Single Select': SingleSelectGroup,
  'Multiple Select': MultipleSelectGroup
};

const NYI = () => <div>NYI</div>;
const typeToComponent = type => {
  return TYPE_COMPONENT_MAP[type] || NYI;
};

export default function CustomQuestions({
  questions,
  disableLabels,
  stacked,
  onChange,
  selectedCategory
}) {
  return (
    <div>
      {questions.map(({ id, name, type, answers }) => {
        const Component = typeToComponent(type);
        return (
          <Component
            stacked={stacked}
            key={`get_quotes_question_${id}`}
            label={disableLabels ? undefined : name}
            name={`get_quotes_question_${id}`}
            initialValue={answers.find(a => a.selected)}
            options={answers.map(({ id, name }) => ({
              value: id,
              label: name
            }))}
            onChange={onChange}
            selectedCategory={selectedCategory}
          />
        );
      })}
    </div>
  );
}

CustomQuestions.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.object),
  disableLabels: PropTypes.bool,
  stacked: PropTypes.bool,
  onChange: PropTypes.func,
  selectedCategory: CategoryType
};
